/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */

export type PlatzApiErrorErrorCode =
  (typeof PlatzApiErrorErrorCode)[keyof typeof PlatzApiErrorErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatzApiErrorErrorCode = {
  spotify_unauthorized: "spotify_unauthorized",
  no_youtube_translation_available: "no_youtube_translation_available",
} as const;
